import { Button, Icon, Tooltip } from 'bold-ui'
import React from 'react'

interface ErrataNotaComplementarButtonProps {
  isAcessoLotacaoCriadora: boolean
  atingiuLimiteErratasNotasComplementares?: boolean
  onClick(): void
}

export function ErrataNotaComplementarButton(props: Readonly<ErrataNotaComplementarButtonProps>) {
  const { isAcessoLotacaoCriadora, atingiuLimiteErratasNotasComplementares, onClick } = props

  const isDisabled = !isAcessoLotacaoCriadora || atingiuLimiteErratasNotasComplementares

  const handleButtonClick = (e: Event) => {
    e.stopPropagation()
    onClick()
  }

  const handleButtonKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      onClick()
    }
  }

  const tooltipText = getTooltipText(isAcessoLotacaoCriadora, atingiuLimiteErratasNotasComplementares)

  return (
    <Tooltip text={tooltipText}>
      <Button
        size='small'
        skin='ghost'
        disabled={isDisabled}
        onClick={(e) => handleButtonClick(e)}
        onKeyDown={handleButtonKeyDown}
        data-testid='ErrataNotaComplementarButton'
      >
        <Icon icon='chatOutline' size={1.5} />
      </Button>
    </Tooltip>
  )
}

function getTooltipText(isAcessoLotacaoCriadora: boolean, atingiuLimiteErratasNotasComplementares?: boolean): string {
  if (!isAcessoLotacaoCriadora) {
    return 'Somente a lotação responsável pelo registro pode registrar erratas ou notas complementares'
  }

  if (atingiuLimiteErratasNotasComplementares) {
    return 'Limite de erratas/notas complementares atingido'
  }

  return 'Registrar errata ou nota complementar'
}
